<template>
  <div id="Customerdialog">
    <el-dialog
      :title="title"
      :before-close="handleClose"
      :visible.sync="Customerdialog"
      :show="show"
      width="635px"
    >
      <el-form :model="CustomerAdd" ref="CustomerAdd" label-width="100px" class="demo-ruleForm">
        <div class="content_box">
          <InputOne
            class="base_select_sty1"
            v-model="CustomerAdd.FullName"
            @clickFocus="CustomerFocus"
            @changeVal="inputVal"
            name="客户名称"
            field="FullName"
          />
          <InputOne
            class="base_select_sty2 margin_l_10"
            v-model="CustomerAdd.BaseCode"
            @clickFocus="CustomerFocus"
            @changeVal="inputVal"
            name="客户编号"
            field="BaseCode"
          />
          <div class="inputicon inputicons base_select_sty2" :class="isactive?'CustomerStyle':''">
            <span class="inputMust_text">所属分类</span>
            <el-input
              v-model="CustomerAdd.ParentNos"
              @focus="CustomerFocus"
              @blur="CustomerBlur"
              :disabled="disabled"
            ></el-input>
            <i class="el-icon-search icons" v-show="iconsearch" @click="clickSearch"></i>
          </div>
          <InputOne
            class="base_select_sty2 margin_l_10"
            v-model="CustomerAdd.PersonID"
            @clickFocus="CustomerFocus"
            @changeVal="inputVal"
            :isMust="false"
            name="经手人"
            field="PersonID"
          />
          <InputOne
            class="base_select_sty2"
            v-model="CustomerAdd.Personcharge"
            @clickFocus="CustomerFocus"
            @changeVal="inputVal"
            name="负责人"
            :isMust="false"
            field="Personcharge"
          />
          <InputOne
            class="base_select_sty1"
            v-model="CustomerAdd.region"
            @clickFocus="CustomerFocus"
            @changeVal="inputVal"
            name="所属地区"
            :isMust="false"
            field="region"
          />
          <InputOne
            class="base_select_sty1"
            v-model="CustomerAdd.Memo"
            @clickFocus="CustomerFocus"
            @changeVal="inputVal"
            name="备注"
            :isMust="false"
            field="Memo"
          />
          <InputOne
            class="base_select_sty1"
            v-model="CustomerAdd.ARLimit"
            @clickFocus="CustomerFocus"
            @changeVal="inputVal"
            name="应收上限"
            :isMust="false"
            field="ARLimit"
          />
          <InputOne
            class="base_select_sty1"
            v-model="CustomerAdd.APLimit"
            @clickFocus="CustomerFocus"
            @changeVal="inputVal"
            name="应付上限"
            :isMust="false"
            field="APLimit"
          />
          <InputOne
            class="base_select_sty1"
            v-model="CustomerAdd.SkLimit"
            @clickFocus="CustomerFocus"
            @changeVal="inputVal"
            name="收款期限"
            :isMust="false"
            field="SkLimit"
          />
          <InputOne
            class="base_select_sty1"
            v-model="CustomerAdd.DeftPrice"
            @clickFocus="CustomerFocus"
            @changeVal="inputVal"
            name="默认价格"
            :isMust="false"
            field="DeftPrice"
          />
          <InputOne
            class="base_select_sty1"
            v-model="CustomerAdd.ChgGoodDay"
            @clickFocus="CustomerFocus"
            @changeVal="inputVal"
            name="换货天数"
            :isMust="false"
            field="ChgGoodDay"
          />
          <InputOne
            class="base_select_sty1"
            v-model="CustomerAdd.ChgGoodScale"
            @clickFocus="CustomerFocus"
            @changeVal="inputVal"
            name="换货比率"
            :isMust="false"
            field="ChgGoodScale"
          />
          <InputOne
            class="base_select_sty1"
            v-model="CustomerAdd.Discount"
            @clickFocus="CustomerFocus"
            @changeVal="inputVal"
            name="折扣"
            :isMust="false"
            field="Discount"
          />
          <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="SureClick('CustomerAdd')">保 存</el-button>
            <el-button @click="cancelClick">取消</el-button>
          </span>
        </div>
      </el-form>
    </el-dialog>
    <el-dialog title="所属分类" :visible.sync="dialogVisible2" width="384px">
      <div class="v_input">
        <el-input v-model="v_input"></el-input>
        <div class="tree">
          <el-tree
            :data="datas"
            :props="defaultProps"
            icon-class="el-icon-folder-opened"
            accordion
            @node-click="handleNodeClicktree"
          ></el-tree>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible2 = false">取 消</el-button>
        <el-button type="primary" @click="Determine">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import vPinyin from "@/utils/PyConversion.js";
import tool from '@/utils/tool.js';
// import local from "../../../../utils/local";
// import session from "../../../../utils/session";
export default {
  name: "Customerdialog",
  components: {
    // InputOne
  },
  data() {
    return {
      isactive: false,
      iconsearch: this.showicon,
      title: this.titletext,
      Customerdialog: this.show,
      dialogVisible2: false,
      datas: [],
      defaultProps: {
        children: "children",
        label: "label"
      },
      disabled: false,
      v_input: "",
      CustomerAdd: {
        FullName: "", //客户名称
        BaseCode: "", //客户编码
        ParentNos: "", //所属分类
        PersonID: "", //经手人
        Personcharge: "", //负责人
        PyNo: "", //助记码
        region: "", //地区
        // Clienttype: "", //客户类型Clienttype
        Memo: "", //备注
        contact: "", //联系人
        Telephone: "", //电话
        address: "", //地址
        ARLimit: 0, // 应收上限
        APLimit: 0, // 应付上限
        SkLimit: 0, // 收款期限
        DeftPrice: 0, // 默认价格方式,适用价格
        ChgGoodDay: 0, // 换货天数
        ChgGoodScale: 0, // 换货比率
        IsVip: 0, // 是否是会员,1-会员,0-非会员
        IsClient: 1, // 0-供应商,1-客户,2-既是客户,又是供应商
        Discount: 1 // 折扣
      }
    };
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    showicon: {
      type: Boolean,
      default: true
    },
    Star: {
      type: Boolean,
      default: true
    },
    titletext: {
      type: String,
      default: "新增"
    }
  },
  methods: {
    handleNodeClicktree(data) {
      session.save("ParentNoCustomer", data);
      this.v_input = data.label;
    },
    Determine() {
      let Parent = tool.getSession("ParentNoCustomer");
      this.CustomerAdd.ParentNos = Parent.label;
      this.dialogVisible2 = false;
    },
    //   分类
    clickSearch() {
      this.dialogVisible2 = true;
    },
    // 聚焦事件
    CustomerFocus() {
      this.isactive = true;
    },
    // 失焦事件
    CustomerBlur() {
      this.isactive = false;
    },
    // 当前input值改变
    inputVal(data, fieldName) {
      this.CustomerAdd[fieldName] = data;
      if (fieldName == "FullName") {
        if (data != "") {
          // 调用自动生成助记码
          this.CustomerAdd.PyNo = vPinyin.makePy(data);
        } else {
          this.CustomerAdd.PyNo = "";
        }
      }
    },
    // 保存
    SureClick(data) {
      // // 取值
      // let company = tool.getSession("company");
      // let BaseNoid = tool.getSession("BaseNo");
      // let Parent = tool.getSession("ParentNoCustomer");
      // // 取值
      // let userid = tool.getLocal("userid");
      // let sessionid = tool.getLocal("sessionid");
      let py = vPinyin.makePy(this.CustomerAdd.FullName);
      let aaa = this.CustomerAdd.FullName;
      if (aaa != "") {
        let params = {
          user_id: tool.getLocal("userid"), //用户ID
          session_id: tool.getLocal("sessionid"), //用户凭证
          ParentNo: tool.getSession("ParentNoCustomer").id, //父级ID
          BaseCode: this.CustomerAdd.BaseCode, //用户编号
          FullName: this.CustomerAdd.FullName, //全名
          Name: this.CustomerAdd.FullName, //简称
          PyNo: py, //助记码
          PersonID: this.CustomerAdd.PersonID, //经手人
          ARLimit: this.CustomerAdd.ARLimit, // 应收上限
          APLimit: this.CustomerAdd.APLimit, // 应付上限
          SkLimit: this.CustomerAdd.SkLimit, // 收款期限
          DeftPrice: parseInt(this.CustomerAdd.DeftPrice), // 默认价格方式,适用价格
          ChgGoodDay: parseInt(this.CustomerAdd.ChgGoodDay), // 换货天数
          ChgGoodScale: parseInt(this.CustomerAdd.ChgGoodScale), // 换货比率
          IsVip: 0, // 是否是会员,1-会员,0-非会员
          IsClient: 1, // 0-供应商,1-客户,2-既是客户,又是供应商
          Discount: this.CustomerAdd.Discount, // 折扣
          Clienttype: this.CustomerAdd.Clienttype, // 客户类型
          Memo: this.CustomerAdd.Memo, //备注
          IsDir: 0
        };
        let jparams = JSON.stringify(params);
        let jparams_top = { jparams: jparams };

        this.request
          .post("/index/Client/add", jparams_top)
          .then(res => {
            this.$emit("SureClick");
          });
      } else {
        return;
      }
    },
    cancelClick() {
      this.$emit("cancelClick");
    },
    // tree树
    clicknede(data) {
      // 取值
      let userid = tool.getLocal("userid");
      let sessionid = tool.getLocal("sessionid");
      let params = {
        user_id: userid, //用户id
        session_id: sessionid //用户凭证
      };
      let jparams = JSON.stringify(params);
      let jparams_tree = { jparams: jparams };
      this.request
        .post("/index/Client/getlist", jparams_tree)
        .then(res => {
          let { status, data, tree } = res;
          let aa = [];
          for (let i = 0; i < tree.length; i++) {
            const element = tree[i];
            aa.push(element);
            session.save("ParentNoCustomer", element);
            this.CustomerAdd.ParentNos = element.label;
            this.CustomerAdd.ParentNo = element.id;
          }
          this.datas = aa;
        });
    },
    // 关闭模态框
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then(_ => {
          this.$emit("cancelClick");
        })
        .catch(_ => {});
    },
    clickBaseCode() {
      // 取值
      let userid = tool.getLocal("userid");
      let sessionid = tool.getLocal("sessionid");
      let Parent = tool.getSession("ParentNoCustomer");
      let params = {
        user_id: userid, //用户id
        session_id: sessionid, //用户凭证
        table: "Goods"
      };
      let jparams = JSON.stringify(params);
      let jparams_tree = { jparams: jparams };
      this.request
        .post(
          "/index/common/get_basecode",
          jparams_tree
        )
        .then(res => {
          let { status, BaseCode } = res;

          if (status == 0) {
            this.CustomerAdd.BaseCode = BaseCode;
          }
        });
    },
    getStaffInfo() {
      // 取值
      let userid = tool.getLocal("userid");
      let sessionid = tool.getLocal("sessionid");
      let params = {
        command: "1010",
        user: {
          user_id: userid,
          session_id: sessionid
        }
      };
      let jparams = JSON.stringify(params);
      let jparams_top = { jparams: jparams };
      this.request
        .post("http://118.190.210.223:10003/user.php", jparams_top)
        .then(res => {
          let { command, result, user } = res;
          if (result.accept == 1) {
            this.CustomerAdd.PersonID = user.telephone;
          } else {
          }
        });
    }
  },
  created() {
    this.clicknede();
    this.clickBaseCode();
    this.getStaffInfo();
  },
  watch: {
    show() {
      this.Customerdialog = this.show;
    }
  }
};
</script>

<style lang="less">
#Customerdialog {
  .content_box {
    width: 100%;
    display: flex;
    flex-wrap: wrap;

    .base_select_sty1 {
      width: 580px;
      margin-top: 10px;
      height: 32px;
      line-height: 26px;
    }

    .base_select_sty2 {
      width: 240px;
      margin-top: 10px;
      line-height: 27px;
    }

    .margin_l_10 {
      margin-right: 99px;
    }

    .dialog-footer {
      width: 100%;
      display: -webkit-box !important;
      display: box !important;
      position: relative;
      -webkit-box-pack: end;
      box-pack: end;
      margin: 20px 0 10px;
    }
  }
  .inputicon {
    width: 100%;
    height: 28px;
    display: flex;
    justify-content: flex-end;
    position: relative;
    border: 1px solid #ccc;
    border-radius: 5px;
    margin-bottom: 15px;

    .el-input__inner {
      border: none;
      height: 27px !important;
      line-height: 28px !important;
      padding: 0;
      text-indent: 14px;
      font-size: 13px;
    }

    .inputMust_text {
      height: 100%;
      width: 66px;
      line-height: 28px;
      font-size: 12px;
      margin-left: 5px;
    }

    .icons {
      position: absolute;
      top: 25%;
      right: 8%;
    }
  }

  .inputicons {
    margin-bottom: 0;
  }

  .inputicon:hover {
    border: 1px solid rgb(22, 123, 238) !important;

    .inputMust_text {
      color: rgb(22, 123, 238);
    }
  }
  .CustomerStyle {
    border-color: #2594ff !important;
    .inputMust_text {
      color: #2594ff !important;
    }
  }
  .v_input {
    .el-input__inner {
      height: 32px;
      color: #000;
      margin-bottom: 15px;
    }
  }

  .tree {
    width: 100%;
    height: 300px;
    overflow: hidden;

    .el-tree {
      width: 100%;
      height: 315px;
      overflow-x: scroll;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Dialog/Customerdialog/Customerdialog.vue